export default __webpack_public_path__ + "static/media/Map1.4fb7556b.png";